<template>
    <views class="edit-img">
        <views class="edit-img-inner">
            <views class="user-img">
                <images :src="avatar"></images>
            </views>
            <!-- <views class="user-icon">
                <images :src="userIcon"></images>
            </views> -->
        </views>
    </views>
</template>

<script>
export default {
    props: {
        avatar: {
            type: String,
            default: require('@/assets/images/user_img_default.png')
        }
    },
    data() {
        return {
            userIcon: require('@/assets/images/user_icon.png')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
